import { useTranslation } from "react-i18next";
import type { Currency, EventValueDto } from "../../../../autogen/bff-api";
import { useFieldErrorTranslation, type FieldError } from "../../../../common/editing/save-coordinator";

export interface PriceCurrencyState {
  shownCurrency: Currency;
  priceError: string | null;
}

export const usePriceCurrencyError = (
  storedPrice: EventValueDto | null | undefined,
  tenderCurrency: Currency,
  saveError: FieldError | undefined,
): PriceCurrencyState => {
  const { t } = useTranslation();
  const formatFieldError = useFieldErrorTranslation();
  const storedCurrency = storedPrice?.value != null ? storedPrice.currency : undefined;
  const inOtherCurrency = storedCurrency != null && storedCurrency !== tenderCurrency;
  const priceError = saveError
    ? formatFieldError(saveError)
    : inOtherCurrency
      ? t("The price must be in {{currency}}, the currency of the contract. Enter it again.", {
          currency: tenderCurrency,
        })
      : null;
  return { shownCurrency: inOtherCurrency ? storedCurrency : tenderCurrency, priceError };
};
